import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card } from '@dreamtree-org/twreact-ui';
import PageShell from '@/components/layout/PageShell';
import PageHeader from '@/components/layout/PageHeader';
import { platformGet, errorOf } from './platformApi';

const STATUSES = ['active', 'draft', 'provisioning', 'provisioning_failed', 'suspended', 'maintenance', 'archived'];

/** P02 — operational counts only; this console never shows a tenant's business records. */
export default function PlatformOverview() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    platformGet('/overview').then(setData).catch((ex) => setErr(errorOf(ex).message));
  }, []);

  return (
    <PageShell className="space-y-3">
      <PageHeader title="Overview" subtitle="Company lifecycle and setup health across the platform." />
      {err && <Alert variant="error">{err}</Alert>}
      {data && (
        <>
          <div className="grid gap-3 grid-cols-2 md:grid-cols-4">
            {STATUSES.map((s) => (
              <Card key={s} className="p-3">
                <Link to={`/platform/companies?status=${s}`} className="block">
                  <div className="text-xs text-secondary-500 capitalize">{s.replace('_', ' ')}</div>
                  <div className="text-2xl font-semibold">{data.companies[s] || 0}</div>
                </Link>
              </Card>
            ))}
          </div>
          <div className="grid gap-3 md:grid-cols-2">
            <Card className="p-3">
              <div className="text-xs text-secondary-500">Failed provisioning jobs</div>
              <div className={`text-2xl font-semibold ${data.failedProvisioningJobs ? 'text-red-600' : ''}`}>{data.failedProvisioningJobs}</div>
            </Card>
            <Card className="p-3">
              <div className="text-xs text-secondary-500">Branch changes waiting to reach company databases</div>
              <div className="text-2xl font-semibold">{data.pendingBranchEvents}</div>
            </Card>
          </div>
        </>
      )}
    </PageShell>
  );
}
